import { Box, Card, CardContent, Divider, Stack, Typography } from '@mui/material';
import { t } from 'i18next';
import { PieChart } from './PieChart';
import { ReportDiff } from '../models/ReportDiff';
import { PieChartSkeleton } from './skeletons/PieChartSkeleton';
import { useComponentResponsiveProps } from '../../../common/hooks/useComponentResponsiveProps';

type Props = {
  reportDiff: ReportDiff | null;
  isLoading: boolean;
};

export const KeyInsightsCard = (props: Props) => {
  const { reportDiff, isLoading } = props;
  const [ref, value] = useComponentResponsiveProps<{ orientation: 'horizontal' | 'vertical' }, HTMLHRElement>({
    xs: { orientation: 'horizontal' },
    lg: { orientation: 'vertical' },
  });
  const isLoadingOrPending = isLoading || reportDiff?.isPending() || reportDiff === null;

  return (
    <Card>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: {
              xs: 'column',
              lg: 'row',
            },
            gap: 4,
          }}
        >
          <Stack direction="column" sx={{ flex: 1, gap: 2 }}>
            <Typography variant="h5" component="p">
              {t('comparison.tabHeaderIssues')}
            </Typography>
            {isLoadingOrPending ? (
              <PieChartSkeleton />
            ) : (
              <PieChart type="issues" selectedCountMap={reportDiff.getSelectedIssuesCountMap()} currentCountMap={reportDiff.getCurrentIssuesCountMap()} />
            )}
          </Stack>
          <Divider orientation={value.orientation} ref={ref} flexItem />
          <Stack direction="column" sx={{ flex: 1, gap: 2 }}>
            <Typography variant="h5" component="p">
              {t('comparison.tabHeaderInstances')}
            </Typography>
            {isLoadingOrPending ? (
              <PieChartSkeleton />
            ) : (
              <PieChart
                type="instances"
                selectedCountMap={reportDiff.getSelectedInstancesCountMap()}
                currentCountMap={reportDiff.getCurrentInstancesCountMap()}
              />
            )}
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
};
